import React from "react";
import "./Separator.scss";

interface SeparatorProps {
  className?: string;
}

export const Separator = ({ className }: SeparatorProps) => {
  return <div className={`howitworks-separator ${className}`} />;
};
